import { render } from "./Auth.vue?vue&type=template&id=19db9639"
import script from "./Auth.vue?vue&type=script&lang=js"
export * from "./Auth.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\projetos\\mestre\\mestre-do-valor-sn-administrativo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__